module.exports = __webpack_public_path__ + "empty_content.7009889fab8adbdced1b4a03bd1a3da5.svg";